module.exports = __webpack_public_path__ + "static/mantenimiento01-8a0a31c481d479b7a65bcedb17d57231.jpg";